import {
  Avatar,
  Box,
  Button,
  IconButton,
  Typography,
  Drawer,
  Skeleton,
  List,
  ListItem,
  ListItemButton,
  Divider,
} from "@mui/material";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { GET_CATEGORIES_N_SUB } from "../../Utils/Queries";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { HashLink } from "react-router-hash-link";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { COLORS } from "../../STYLES/color";
import MaButton from "../UI/ma-button";

const getUserInitials = (user) => {
  if (!user) return "?";
  return `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase() || "?";
};

const CategoryMenu = () => {
  const isAuthenticated = useSelector((state) => state.user?.isAuthenticated);
  const userInfo = useSelector((state) => state.user?.user?.profile);
  const [openDrawer, setOpenDrawer] = useState(false);
  // const loading = true;
  const { loading, data, error } = useQuery(GET_CATEGORIES_N_SUB);

  const isSeller = useSelector(
    (state) => state.user?.user?.profile?.hasPaidMembershipFee,
  );

  const displayName = [userInfo?.firstName, userInfo?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const [collapse, setCollapse] = useState(false);
  return (
    <>
      <div className="flex items-center gap-x-4 w-fit">
        <IconButton
          onClick={() => setOpenDrawer(true)}
          sx={{ borderRadius: "0px", ml: -1 }}
        >
          <MenuIcon sx={{ color: "#1a1a1a" }} />
          <Typography
            variant="caption"
            sx={{ color: "#1a1a1a", ml: 1, fontWeight: 600 }}
          >
            All
          </Typography>
        </IconButton>

       
      </div>

      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Box sx={{ width: "400px", bgcolor: COLORS.WHITE, height: "100%" }}>
          <Box
            sx={{
              p: 2.5,
              px: 3,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
              background:
                "linear-gradient(135deg, #F7F4FA 0%, #FFFFFF 55%, #D6B8DF 100%)",
              borderBottom: "1px solid #EAEAEA",
            }}
          >
            {isAuthenticated ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.75, minWidth: 0, flex: 1 }}>
                <Avatar
                  src={userInfo?.imageUrl || undefined}
                  alt={displayName || "User"}
                  sx={{
                    width: 52,
                    height: 52,
                    bgcolor: COLORS.PRIMARY_DARK,
                    color: "#fff",
                    fontSize: "15px",
                    fontWeight: 700,
                    border: "2px solid #fff",
                    boxShadow: "0 8px 24px rgba(46, 24, 52, 0.12)",
                  }}
                >
                  {!userInfo?.imageUrl ? getUserInitials(userInfo) : null}
                </Avatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    sx={{
                      color: "#1A1A1A",
                      fontSize: "15px",
                      fontWeight: 700,
                      lineHeight: 1.25,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      mb:-0.3
                    }}
                  >
                    {displayName || "Hello"}
                  </Typography>
                  {userInfo?.email ? (
                    <Typography
                      sx={{
                    
                        color: "#6B7280",
                        fontSize: "12px",
                        fontWeight: 500,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {userInfo.email}
                    </Typography>
                  ) : null}
                  <Link
                    to="/account"
                    onClick={() => setOpenDrawer(false)}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      sx={{
                      
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.25,
                        color: COLORS.PRIMARY_DARK,
                        fontSize: "12px",
                        fontWeight: 700,
                        textDecoration: "underline",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      View profile
                      
                    </Typography>
                  </Link>
                </Box>
              </Box>
            ) : (
              <Box sx={{ minWidth: 0, flex: 1, pt: 0.5 }}>
                <Typography
                  sx={{
                    color: "#1A1A1A",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Hello, Sign In
                </Typography>
                <Typography
                  sx={{
                    mt: 0.5,
                    color: "#6B7280",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: 1.4,
                  }}
                >
                  Sign in to access your account and preferences.
                </Typography>
              </Box>
            )}
            <IconButton
              sx={{ color: "#fff", mt: -0.5, flexShrink: 0 }}
              onClick={() => setOpenDrawer(false)}
            >
              <CloseOutlined sx={{ color: COLORS.TEXT_BLACK }} />
            </IconButton>
          </Box>

          <Divider />

          <Box
            sx={{
              p: 2,
              px: 3,
              height: "87vh",
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                width: "0", // Set the width of the scrollbar to zero
              },
            }}
          >
            <Box sx={{}}>
              <Box
                onClick={() => setCollapse(!collapse)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: COLORS.TEXT_GREY,
                    "&:hover": {
                      color: COLORS.TEXT_BLACK,
                    },
                  }}
                >
                  CATEGORIES
                </Typography>
                <IconButton
                  onClick={() => setCollapse(!collapse)}
                  sx={{ color: COLORS.TEXT_BLACK }}
                >
                  {collapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Box sx={{ py: 1, display: collapse ? "block" : "none" }}>
                {loading ? (
                  <>
                    <ListLoader />
                  </>
                ) : (
                  <>
                    {data?.fetchAllCategoriesAndTheirSubCategories.map(
                      (item, index) => (
                        <Link
                          key={index}
                          to={`/category-view/${item.category.name}/${item.category._id}`}
                        >
                          <ListItemButton
                            sx={{
                              p: 0,
                              px: 1,
                              py: 1,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 0,
                            }}
                          >
                            <Typography
                              sx={{
                                color: COLORS.TEXT_BLACK,
                                fontWeight: 500,
                                fontSize: "14px",
                              }}
                            >
                              {item?.category?.name}
                            </Typography>

                            <IconButton>
                              {/* <ChevronRightIcon /> */}
                            </IconButton>
                          </ListItemButton>
                        </Link>
                      ),
                    )}
                  </>
                )}
              </Box>
            </Box>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 700, color: COLORS.TEXT_GREY }}>
                DEALS
              </Typography>
              <Box sx={{ mt: 2 }}>
                <HashLink
                  to="/#latestProducts"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                    }}
                  >
                    Latest
                  </Typography>
                </HashLink>
                <HashLink
                  to="/#topProducts"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 1,
                    }}
                  >
                    Top Sellers
                  </Typography>
                </HashLink>
              </Box>
            </Box>
            <Box sx={{ mt: 4 }}>
              {isSeller ? (
                <Link to="/sell-on-mamaket">
                  <MaButton
                    variant={"primary"}
                    title="Sell on Mamaket"
                    fullWidth
                    sx={{ bgcolor: COLORS.BLACK }}
                  />
                </Link>
              ) : (
                <Link to="/become-a-seller">
                  <MaButton
                    variant={"primary"}
                    title="Become A Seller"
                    fullWidth
                    sx={{ bgcolor: COLORS.BLACK }}
                  />
                </Link>
              )}
            </Box>
            <Divider sx={{ my: 3 }} />
            <Box sx={{}}>
              <Typography sx={{ fontWeight: 700, color: COLORS.TEXT_GREY }}>
                QUiCK LINKS
              </Typography>
              <Box sx={{ mt: 2 }}>
                <Link to="/explore-culture" onClick={() => setOpenDrawer(false)}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                    }}
                  >
                    Explore Culture
                  </Typography>
                </Link>
                </Box>
                <Box sx={{ mt: 2 }}>
                <Link to="/chat" onClick={() => setOpenDrawer(false)}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                    }}
                  >
                    Chat
                  </Typography>
                </Link>

                <Link
                  to="/referral"
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                  Referral
                  </Typography>
                </Link>
                <Link
                  to="/ma-agent"
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                Cultural Festivals & Events
               
                  </Typography>
                </Link>
                <Link
                  to="/account/orders"
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
Track my Order
               
                  </Typography>
                </Link>
                <Link
                  to="/account/mamapurse"
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    Mamapurse
                  </Typography>
                </Link>
               
                {/* <Link to="/account" onClick={() => setOpenDrawer(false)}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    My Profile
                  </Typography>
                </Link> */}
              </Box>
            </Box>
            <Divider sx={{ my: 3 }} />
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 700, color: COLORS.TEXT_GREY }}>
                MAMAKET
              </Typography>
              <Box sx={{ pb: 10 }}>
                <Link to="/about-us" onClick={() => setOpenDrawer(false)}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    About Us
                  </Typography>
                </Link>
                <HashLink
                  to="/#ourvalue"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    Our Value
                  </Typography>
                </HashLink>
                <HashLink
                  to="/#news"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  onClick={() => setOpenDrawer(false)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    News Update
                  </Typography>
                </HashLink>
                <Link to="/contact" onClick={() => setOpenDrawer(false)}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 500,
                      mt: 2,
                    }}
                  >
                    Contact Us
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              position: "absolute",
              bgcolor: COLORS.WHITE,
              bottom: 0,
              width: "100%",
              borderTop: "1px solid",
              borderColor: COLORS.BORDER_GREY,
              pt: 2,
            }}
          >
            <Typography sx={{ mb: 3, pl: 2 }}>
              © {new Date().getFullYear()} Platform. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default CategoryMenu;

const ListLoader = () => {
  return (
    <>
      <Skeleton variant="square" sx={{ width: "30%", mb: 1 }} />
      <Skeleton variant="square" sx={{ width: "70%", mb: 1 }} />
      <Skeleton variant="square" sx={{ width: "50%", mb: 1 }} />
    </>
  );
};
